import { FormEvent, useState } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import { ApiError, login } from '../lib/api';
import { safeNext } from '../lib/safe-next';

export default function Login() {
  const [params] = useSearchParams();
  const next = safeNext(params.get('next'));
  const navigate = useNavigate();
  const [identifier, setIdentifier] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);

  async function onSubmit(e: FormEvent) {
    e.preventDefault();
    setBusy(true);
    setError('');
    try {
      await login(identifier, password);
      navigate(next);
    } catch (err) {
      setError(err instanceof ApiError ? '登录失败，请检查账号或密码' : '登录失败');
    } finally {
      setBusy(false);
    }
  }

  return (
    <section className="work-card stack" style={{ maxWidth: 420, marginInline: 'auto' }}>
      <h1 className="type-display-md text-ink">登录</h1>
      <p className="type-body-md text-ink-secondary">使用手机号、用户名或邮箱登录。忘记密码请联系管理员重置。</p>
      <form className="stack" onSubmit={onSubmit}>
        <label className="field">
          账号
          <input
            className="form-control"
            value={identifier}
            onChange={(e) => setIdentifier(e.target.value)}
            required
          />
        </label>
        <label className="field">
          密码
          <input
            className="form-control"
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
            minLength={8}
          />
        </label>
        {error ? <div className="error">{error}</div> : null}
        <button className="btn-primary" type="submit" disabled={busy}>
          {busy ? '登录中…' : '登录'}
        </button>
      </form>
      <p className="type-body-md text-ink-secondary">
        还没有账号？<Link to={`/register?next=${encodeURIComponent(next)}`}>注册</Link>
      </p>
    </section>
  );
}
